export const questions = [
  {
    question: 'Which Stephen King book did Joey hide in his freezer?',
    correct_answer: 'The Shining',
    incorrect_answers: ['Pet Sematary', 'Carrie', 'It'],
  },
  {
    question: 'How many sisters does Joey have?',
    correct_answer: '7',
    incorrect_answers: ['5', '3', '8'],
  },
  {
    question: 'What is Ross’ profession?',
    correct_answer: 'Palaeontologist',
    incorrect_answers: ['Geologist', 'Astronomer', 'Museum tour guide'],
  },
  {
    question: 'What instrument did Ross intend to play at Monica and Chandler’s wedding?',
    correct_answer: 'Bagpipes',
    incorrect_answers: ['Keyboard', 'Drunks', 'Saxophone'],
  },
  {
    question: 'What is Chandler’s middle name?',
    correct_answer: 'Muriel',
    incorrect_answers: ['Nora', 'Charles', 'Francis'],
  },
  {
    question: 'Which of Joey’s sisters does Chandler kiss?',
    correct_answer: 'Mary Angela',
    incorrect_answers: ['Mary Therese', 'Dina', 'Cookie'],
  },
  {
    question: 'Which toe does Chandler lose when Monica drops the knife on his foot?',
    correct_answer: 'Right foot pinkie',
    incorrect_answers: ['Left foot big toe', 'Right foot big toe', 'Left foot pinkie'],
  },
  {
    question: 'What is the name of Chandler’s favourite Baywatch star?',
    correct_answer: 'Yasmine Bleeth',
    incorrect_answers: ['Nancy Valen', 'Pamela Anderson', 'Kelly Slater'],
  },
  {
    question: 'What film character did Rachel dress up as to fulfil Ross’ fantasy?',
    correct_answer: 'Princess Leia',
    incorrect_answers: ['Supergirl', 'Little Bo Peep', 'Cat Woman'],
  },
  {
    question: 'How many pages were in the letter Rachel wrote to Ross (front and back!)?',
    correct_answer: '18',
    incorrect_answers: ['12', '8', '16'],
  },
  {
    question: 'Which famous actor does Rachel go on date with after meeting him on a movie set?',
    correct_answer: 'Jean-Claude van Damme',
    incorrect_answers: ['Bruce Willis', 'Ben Stiller', 'Brad Pitt'],
  },
  {
    question: 'What happens to Rachel’s boss, Joanna, the night before her promotion goes through?',
    correct_answer: 'She gets hit by a taxi',
    incorrect_answers: ['She goes on a date with Chandler', 'She falls down an elevator shaft', 'She moves to Paris'],
  },
  {
    question: 'What is the name of the hairless cat Rachel gets for herself?',
    correct_answer: 'Mrs Whiskerson',
    incorrect_answers: ['Fluffy', 'Chi Chi', 'Mozzarella'],
  },
  {
    question: 'What was the name of the ice-dancer Phoebe was married to?',
    correct_answer: 'Duncan',
    incorrect_answers: ['Mike', 'Gary', 'David'],
  },
  {
    question: 'What was the name of the neighbour’s dog who’d chase Phoebe as a child?',
    correct_answer: 'Satan',
    incorrect_answers: ['Lily', 'Clunkers', 'Candy'],
  },
]